<template>
  <main class="main-content" id="main-content">
    <div class="container" v-if="loaded">
      <section class="section">
        <page-header>
          <template v-slot:pageTitle>
            {{$t("finance")}}
          </template>
        </page-header>
        <div class="section__body" v-if="finance?.ContractObject">
          <finance-body v-for="contract in finance.ContractObject" :contract="contract" :key="contract.idContract" @setContractData="setContractData"></finance-body> 
        </div>
        <div class="section__body disabled" v-else>
          {{$t("dataNotFound")}}
        </div>
      </section>
    </div>
  </main>
  <!-- Оплата онлайн -->
  <div class="modal fade modal_form modal_pay-online show" v-show="showModal" id="modal-pay-online" :aria-label='$t("onlinePayment")' tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title section__title section__title_style3">
            {{$t("onlinePayment")}}
          </div>
          <button ref="closeBtn" class="btn svg-icon modal-close" @click="closeModal" type="button" data-dismiss="modal" aria-label="Закрыть">
            <svg role="img" width="14" height="14" aria-hidden="true">
              <use xlink:href="#svg-icon-close"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="payment-methods" v-show="isVisible === 'methods'">   
            <div class="payment-item" @click="payKaspi">
              <svg width="120" height="33" viewBox="0 0 141 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7475 17.6513C19.6113 18.0934 19.9984 19.7879 20.2299 21.365L20.2685 21.6339L20.2948 21.8169L20.4342 22.745C20.707 24.5171 21.2762 28.1955 21.2762 30.115C21.2762 30.5947 21.234 30.9629 21.1569 31.1652C21.0284 31.477 20.654 31.7762 20.137 32.0256C18.8861 32.3335 17.5786 32.5 16.2318 32.5C16.0892 32.5 15.9489 32.4931 15.8081 32.4889C15.2638 32.3343 14.8547 32.0762 14.6381 31.7235C13.9841 30.6589 13.9447 28.287 13.9316 25.5152L13.9301 25.1937L13.9248 24.3629C13.9035 21.4286 13.8852 18.8986 14.9513 17.9907C15.3642 17.6415 15.9509 17.5259 16.7475 17.6513ZM10.5037 24.0398C11.1243 24.0049 11.5234 27.0574 11.6036 29.3721C11.6598 30.9836 11.4906 31.6465 11.2204 31.8845C10.9145 31.7824 10.6139 31.6719 10.3177 31.5519C10.1201 31.1928 9.96907 30.628 9.87312 29.8882C9.58018 27.5633 9.83465 24.0808 10.5037 24.0398ZM26.0622 28.6014C26.0235 28.8134 25.9689 28.9772 25.9016 29.1154C25.371 29.5412 24.8133 29.9321 24.2297 30.2838C24.0438 30.3151 23.8787 30.2933 23.798 30.1569C23.0245 28.7978 22.7342 24.5342 23.4827 24.1631C24.4586 23.6917 26.2069 27.8643 26.0622 28.6014ZM16.0008 0.5C24.7145 0.5 31.8006 7.40062 31.996 15.9873L32 16.2841V16.4213C31.984 20.3 30.5566 23.8486 28.205 26.5952C28.1197 26.5524 27.9641 26.4123 27.6822 25.9906C27.3905 25.5667 24.8749 21.6953 24.8749 17.2581C24.8749 16.3873 26.1301 15.027 27.2408 13.833C28.0711 12.9345 28.8576 12.087 29.1472 11.4209C29.5161 10.5614 29.258 9.96125 28.8498 9.75782C28.4803 9.57703 27.9256 9.7089 27.5363 10.4003C26.8975 11.5193 26.6928 11.7284 25.761 12.4771C24.8441 13.2254 23.3864 13.9787 23.3864 13.0036C23.3864 12.4771 24.1983 11.2847 24.5994 10.4489C25.009 9.60377 24.5675 8.99196 23.7217 8.99196C22.0608 8.99196 20.9583 11.1077 20.9583 11.8407C20.9583 12.5731 21.3136 12.6774 21.3136 13.5303C21.3136 14.3896 19.4913 15.5042 17.7747 15.5042C16.122 15.5042 15.1636 15.1697 14.7665 14.2273L14.7158 14.095L14.601 13.7554C14.1938 12.5653 13.9017 11.7022 13.3932 10.8002C13.1232 10.3232 12.7066 9.99252 12.3463 9.70156C11.8754 9.33579 11.6311 8.99901 11.5801 8.74784C11.5331 8.49865 11.5078 8.02904 12.3128 6.9465C13.1161 5.87014 13.2287 5.057 12.8267 4.63743C12.681 4.48817 12.4326 4.39254 12.1136 4.39254C11.5494 4.39254 10.7654 4.69149 9.95745 5.51265C8.7015 6.7996 9.41451 8.02149 9.41451 8.55788C9.41451 9.09392 9.18442 9.39713 8.43071 10.1264C7.67148 10.8589 7.40945 11.4869 7.32262 14.0109C7.28935 15.3114 7.06031 16.06 6.85471 16.7238C6.67705 17.3056 6.51366 17.8526 6.50483 18.6429C6.49076 19.5187 6.63654 20.0831 6.80666 20.7343C6.97369 21.3362 7.15109 22.0259 7.26475 23.1796C7.44553 24.9655 7.38268 26.4741 7.054 28.016L6.96628 28.4023L6.94578 28.5133C6.87847 28.7843 6.79846 29.1134 6.69031 29.2367C2.64076 26.3604 0 21.663 0 16.3531C0 7.59843 7.1635 0.5 16.0008 0.5Z" fill="#F14635"/>
                <path d="M93.1086 11.4708C94.6917 11.4708 95.9225 12.0314 96.8012 13.1526C97.6797 14.2738 98.1189 15.815 98.1189 17.7761V17.9586C98.1189 19.8741 97.6698 21.4039 96.7715 22.5479C95.8729 23.6919 94.66 24.2639 93.1323 24.2639C91.953 24.2639 90.9833 23.8496 90.2234 23.0211V29.2461H86.2224V11.6989H89.9623L90.0811 12.8391C90.8488 11.9269 91.858 11.4708 93.1086 11.4708ZM65.2084 11.4708C66.8468 11.4708 68.1409 11.8547 69.0908 12.6224C70.0406 13.3902 70.5274 14.443 70.5511 15.7808V21.2424C70.567 22.375 70.749 23.2415 71.0973 23.842V24.0359H67.0961C66.9537 23.785 66.827 23.4164 66.7162 22.9299C65.9801 23.8192 64.9511 24.2639 63.6293 24.2639C62.4182 24.2639 61.3893 23.9123 60.5423 23.2092C59.6954 22.5061 59.2719 21.6224 59.2719 20.5582C59.2719 19.2204 59.7864 18.2094 60.8154 17.5253C61.8444 16.8412 63.3404 16.4991 65.3033 16.4991H66.5381V15.8492C66.5381 14.7166 66.0276 14.1503 65.0065 14.1503C64.0567 14.1503 63.5818 14.5988 63.5818 15.4957H59.5806C59.5806 14.3023 60.1089 13.3332 61.1657 12.5882C62.2223 11.8433 63.5699 11.4708 65.2084 11.4708ZM78.2325 11.4708C79.9262 11.4708 81.2876 11.8395 82.3166 12.5768C83.3457 13.3142 83.8601 14.2833 83.8601 15.4843H79.8472C79.8472 14.4962 79.3049 14.0021 78.2206 14.0021C77.801 14.0021 77.4488 14.1142 77.1639 14.3384C76.8789 14.5627 76.7364 14.842 76.7364 15.1765C76.7364 15.5186 76.9106 15.796 77.2588 16.0088C77.6071 16.2217 78.1631 16.3965 78.9269 16.5333C79.6907 16.6702 80.3616 16.8336 80.9395 17.0236C82.8708 17.6621 83.8363 18.8061 83.8363 20.4556C83.8363 21.5806 83.316 22.4966 82.2751 23.2035C81.2342 23.9104 79.8867 24.2639 78.2325 24.2639C77.1322 24.2639 76.1507 24.0739 75.288 23.6938C74.4252 23.3137 73.7524 22.7968 73.2695 22.1431C72.7867 21.4894 72.5453 20.8015 72.5453 20.0794H76.2853C76.3011 20.6494 76.4989 21.0656 76.8789 21.3279C77.2588 21.5901 77.7455 21.7212 78.3392 21.7212C78.8853 21.7212 79.2951 21.6148 79.5681 21.402C79.8412 21.1891 79.9776 20.9117 79.9776 20.5696C79.9776 20.2428 79.7997 19.9805 79.4434 19.7829C79.0872 19.5853 78.4104 19.38 77.4132 19.1672C76.4159 18.9544 75.5927 18.675 74.9436 18.3291C74.2946 17.9833 73.7999 17.5633 73.4595 17.0692C73.1192 16.5751 72.949 16.0088 72.949 15.3703C72.949 14.2377 73.4358 13.3047 74.4093 12.5711C75.3829 11.8376 76.6573 11.4708 78.2325 11.4708ZM48.1713 6.50049V14.7546L53.8342 6.50049H58.987L52.6592 14.7774L58.5007 24.0359H53.5616L49.881 17.856L48.1713 19.6575V24.0359H44.0039V6.50049H48.1713ZM104.589 11.6989V24.0359H100.576V11.6989H104.589ZM139.873 11.6989V13.774L134.151 21.0713H140.004V24.0359H129.093V21.8923L134.792 14.6634H128.078L130.752 11.6989H139.873ZM109.954 20.0563C111.049 20.0563 111.935 20.9112 111.935 21.9659C111.935 23.0205 111.049 23.8755 109.954 23.8755C108.86 23.8755 107.973 23.0205 107.973 21.9659C107.973 20.9112 108.86 20.0563 109.954 20.0563ZM119.246 6.5V15.7139L119.65 15.2058L122.674 11.6376H127.483L122.972 16.6624L127.781 23.8551H123.186L120.377 19.3046L119.246 20.3773V23.8551H115.234V6.5H119.246ZM66.5381 18.5515H65.3746C63.9815 18.5515 63.285 19.152 63.285 20.353C63.285 20.7027 63.4076 20.9858 63.653 21.2025C63.8984 21.4191 64.211 21.5274 64.591 21.5274C65.0896 21.5274 65.5032 21.4248 65.8317 21.2196C66.1602 21.0143 66.3956 20.7825 66.5381 20.524V18.5515ZM92.1232 14.4354C91.1734 14.4354 90.54 14.7622 90.2234 15.4159V20.2732C90.5717 20.9573 91.2129 21.2994 92.1469 21.2994C93.4213 21.2994 94.0782 20.2428 94.1177 18.1296V17.7191C94.1177 15.53 93.453 14.4354 92.1232 14.4354ZM102.637 6.5C103.731 6.5 104.618 7.39564 104.618 8.5005C104.618 9.60536 103.731 10.501 102.637 10.501C101.543 10.501 100.656 9.60536 100.656 8.5005C100.656 7.39564 101.543 6.5 102.637 6.5Z" fill="black"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="mdi-qrcode-scan" width="33" height="33" viewBox="0 0 24 24"><path d="M4,4H10V10H4V4M20,4V10H14V4H20M14,15H16V13H14V11H16V13H18V11H20V13H18V15H20V18H18V20H16V18H13V20H11V16H14V15M16,15V18H18V15H16M4,20V14H10V20H4M6,6V8H8V6H6M16,6V8H18V6H16M6,16V18H8V16H6M4,11H6V13H4V11M9,11H13V15H11V13H9V11M11,6H13V10H11V6M2,2V6H0V2A2,2 0 0,1 2,0H6V2H2M22,0A2,2 0 0,1 24,2V6H22V2H18V0H22M2,18V22H6V24H2A2,2 0 0,1 0,22V18H2M22,22V18H24V22A2,2 0 0,1 22,24H18V22H22Z" /></svg>
            </div>





          <!-- <form id="form-pay-online" name="formPayOnline" action="https://kaspi.kz/online" method="post">
            <input type="hidden" name="Amount" :value="10000">
            <input type="hidden" name="TranId" value="45656428875">
            <input type="hidden" name="OrderId" :value="currentContractNumber">
            <input type="hidden" name="Service" value="TransTelecom_contract">
            <input type="hidden" name="returnUrl" value="https://cabinet.ttc.kz/finances">
            <input type="hidden" name="Signature" value="">
            <input type="hidden" name="user-agreement" value="согласие с договором публичной оферты">

                  <button class="btn btn_default" type="submit">{{$t("pay")}}</button>
          </form> -->






      <div v-if="profile.id_client === 'CNG_78009'">
            <div class="payment-item" @click="isVisible = 'card'">
              <span class="payment-title">
                {{ $t("payWithCard") }}
              </span>
              <svg width="33px" height="33px" viewBox="0 0 16 16" class="bi bi-credit-card" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
                <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
              </svg>
            </div>
            <div class="payment-item" @click="isVisible = 'balance'">
              <span class="payment-title">
                {{ $t("payWithBalance") }}
              </span>
              <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 96 96" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path d="M65.997 12h-36c-3.312 0-5.997 2.688-5.997 6v60c0 3.312 2.685 6 5.997 6h36c3.315 0 6.003-2.688 6.003-6v-60c0-3.312-2.688-6-6.003-6zM39 15h15l0.186 3h-15.186v-3zM47.937 79.5c-1.656 0-3-1.341-3-3s1.344-3 3-3c1.659 0 3 1.341 3 3s-1.344 3-3 3zM65.997 69h-36l0.063-48h35.937v48z"/>
              </svg>
            </div>
            <div class="payment-btn">
              <div class="pay-btns">
                <div class="pay-btn" @click="isVisible = 'apple_pay'">
                  <svg version="1.1" height="33" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px" y="0px" viewBox="0 0 512 210.2" xml:space="preserve">
                    <path id="XMLID_34_" d="M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9
                      C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2
                      c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7
                      c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2
                      C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z
                      M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2
                      c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8
                      c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4
                      l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5
                      l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z
                      "/>
                  </svg>
                </div>
                <div class="pay-btn" @click="isVisible = 'google_pay'">
                  <svg viewBox="0 0 356.44 141.39000000000001" xmlns="http://www.w3.org/2000/svg" height="33"><g fill="#5f6368"><path d="M168.58 20.77V56.5h22.04c5.25 0 9.59-1.76 13.02-5.29 3.53-3.52 5.29-7.72 5.29-12.58s-1.76-8.91-5.29-12.44c-3.44-3.62-7.78-5.43-13.02-5.43h-22.04zm0 48.32v41.45h-13.16V8.19h34.91c8.87 0 16.39 2.96 22.6 8.86 6.31 5.9 9.45 13.1 9.45 21.58s-3.14 15.92-9.45 21.72c-6.1 5.82-13.64 8.72-22.6 8.72h-21.75zM235.68 89.08c0 3.44 1.45 6.29 4.37 8.58 2.91 2.28 6.32 3.43 10.23 3.43 5.54 0 10.46-2.05 14.8-6.14 4.34-4.1 6.51-8.91 6.51-14.43-4.1-3.25-9.83-4.86-17.17-4.86-5.34 0-9.8 1.29-13.37 3.86s-5.37 5.75-5.37 9.56m17.03-50.88c9.73 0 17.41 2.59 23.04 7.79s8.43 12.31 8.43 21.36v43.17h-12.59v-9.72h-.57c-5.44 8-12.68 12-21.74 12-7.73 0-14.2-2.28-19.39-6.85-5.2-4.58-7.8-10.29-7.8-17.16 0-7.24 2.73-13 8.22-17.28 5.49-4.29 12.81-6.43 21.96-6.43 7.82 0 14.26 1.43 19.31 4.29v-3c0-4.57-1.81-8.45-5.43-11.64-3.63-3.2-7.86-4.79-12.73-4.79-7.35 0-13.16 3.09-17.45 9.29l-11.6-7.29c6.4-9.15 15.84-13.72 28.34-13.72M356.44 40.49l-43.93 100.9h-13.59l16.31-35.3-28.9-65.6h14.31l20.89 50.31h.28l20.32-50.31z"/></g><path d="M115.39 60.14c0-4.14-.35-8.14-1.01-11.96H58.86v22.65h31.79c-1.36 7.38-5.49 13.66-11.75 17.87v14.71h18.98c11.11-10.24 17.51-25.37 17.51-43.26" fill="#4285f4"/><path d="M58.86 117.61c15.89 0 29.26-5.21 39.02-14.2L78.9 88.7c-5.28 3.55-12.08 5.63-20.04 5.63-15.35 0-28.38-10.34-33.05-24.27H6.27v15.15c9.69 19.21 29.6 32.41 52.6 32.41" fill="#34a853"/><path d="M25.82 70.05c-1.19-3.55-1.85-7.34-1.85-11.25s.65-7.7 1.85-11.25V32.4H6.27C2.26 40.34 0 49.3 0 58.8s2.26 18.47 6.27 26.4z" fill="#fabb05"/><path d="M58.86 23.27c8.67 0 16.45 2.98 22.58 8.82s16.8-16.78 16.8-16.78C88.04 5.83 74.74 0 58.86 0 35.87 0 15.96 13.19 6.27 32.4l19.55 15.15c4.66-13.93 17.69-24.27 33.05-24.27" fill="#e94235"/></svg>
                </div>
                
              
              </div>
            </div>
      </div>
            <!-- <div class="payment-item" @click="isVisible = 'epay'">
              <img src="images/content/epay.png" alt="epay">
            </div> -->
          </div>
          
          <!-- <form id="form-pay-online" v-show="isVisible === 'kaspi'" name="formPayOnline" action="https://kaspi.kz/online" method="post" @submit="payKaspi">
            <div class="form-group">
              <label class="form-label" for="pay-online-sum">{{$t("payment")}}, {{$t("tg")}}</label>
              <input class="form-control" type="number" v-model="paySumKaspi" name="Amount" id="pay-online-sum" placeholder="0.00" min="100" required="required"/>
            </div>
            <input type="hidden" name="TranId">
            <input type="hidden" name="OrderId">
            <input type="hidden" name="Service">
            <input type="hidden" name="returnUrl">
            <input type="hidden" name="Signature" value="">

            <div class="checkbox">
              <label class="checkbox__label" for="user-agreement">
                <input class="checkbox__hidden" v-model="isAgree" type="checkbox" id="user-agreement" name="user-agreement" value="согласие с договором публичной оферты"/><span class="checkbox__custom" aria-hidden="true">
                  <svg role="img" width="10" height="10">
                    <use xlink:href="#svg-icon-check"></use>
                  </svg></span>
                  <span class="checkbox__title">
                    {{$t("agreeTextPay")}}
                    <a href="https://ttc.kz/files/ru/documents/public_new.pdf" target="_blank">{{$t("publicOffer")}}</a>
                  </span>
              </label>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6">
                  <button :disabled="!isAgree" :class="isAgree ? 'btn_green' : 'is_disabled'" class="btn btn_default" type="submit">{{$t("pay")}}</button>
                </div>
              </div>
            </div>
          </form> -->
          <form class="epay" v-show="isVisible === 'epay'">
            <div class="form-group">
              <label class="form-label" for="pay-online-sum">{{$t("payment")}}, {{$t("tg")}}</label>
              <input class="form-control" type="number" v-model="paySumEpay" name="Amount" id="pay-online-sum" placeholder="0.00" min="100" required="required"/>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6">
                  <button class="btn btn_green btn_default" @click="payEpay" type="button">{{$t("pay")}}</button>
                </div>
              </div>
            </div>
          </form>

          <form v-show="isVisible === 'wooppay'" class="card-list">
            <div class="card-pay"> 
              <div v-for="card in wooppayCardList.cards" class="card" @click="payExistCard(card.id)">
                <span class="card-data">
                  <svg width="33px" height="33px" viewBox="0 0 16 16" class="bi bi-credit-card" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
                    <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
                  </svg>
                  {{ card.hash }}
                </span>
                <div class="card-delete" @click="deleteCard(card.id, wooppayCardList.token)">
                  <svg width="33px" height="33px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </div>
              </div>
              
            </div>
            <button class="btn btn_green btn_default" @click="payNewCard" type="button">{{ $t("newCard") }}</button>
          </form>
          <form v-show="isVisible === 'card' || isVisible === 'apple_pay' || isVisible === 'google_pay'" class="pay-balance-form">
            <input type="text" class="form-control" :placeholder='$t("paySum")' v-model="amountForWooppay">
            <button class="btn btn_green btn_default" @click="wooppayCard_AGP(isVisible)" type="button">{{ $t("pay") }}</button>
          </form>
          <form v-show="isVisible === 'balance'" class="pay-balance-form">
            <div>
              <input type="text" class="form-control" :placeholder='$t("phoneNumber")' v-model="phoneNumberForWooppay">
            </div>
            <input type="text" class="form-control" :placeholder='$t("paySum")' v-model="amountForWooppay">
            <button class="btn btn_green btn_default" @click="wooppayBalance()" type="button">{{ $t("pay") }}</button>
          </form>
          <form v-show="isVisible === 'wooppay-balance'" class="pay-balance-form">
            <input type="text" class="form-control" placeholder="SMS code" v-model="smsCode">
            <button class="btn btn_green btn_default" @click="payBalance" type="button">{{ $t("pay") }}</button>
          </form>
        </div>
      </div>
    </div>
  </div>  
</template>
<script>
// import {halyk} from '@/store/payment-api.js'
const { halyk } = require('@/store/payment-api.js');
import PageHeader from "@/components/PageHeader";
import FinanceBody from "@/components/FinanceBody";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  components: {
    PageHeader,
    FinanceBody,
  },
  data() {
    return {
      preloader: document.querySelector('.preloader'),
      paySumKaspi: '',
      paySumEpay: '',
      loaded: false,
      showModal: false,
      isVisible: 'methods',
      isAgree: false,
      currentContractNumber: '',
      currentContractDebt: '',
      invoiceID: '',
      wooppayCardList: [],
      smsCode: '',
      phoneNumberForWooppay: '',
      amountForWooppay: '',
      ext_id: ''
    }
  },
  methods: {
    ...mapActions({
      getProfile: 'profile/getProfile',
      getFinance: 'finance/getFinance',
      payment: 'finance/payment',
      authWooppay: 'finance/authWooppay',
      authWooppayB: 'finance/authWooppayB',
      paymentWooppay: 'finance/paymentWooppay',
      paymentWooppayBalance: 'finance/paymentWooppayBalance',
      getCards: 'finance/getWooppayCard',
      payWithCard: 'finance/payWithCard',
      deleteExistCard: 'finance/deleteCard',
      payWoopBalance: 'finance/payWoopBalance'
    }),
    payKaspi() {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = process.env.VUE_APP_KSPI_URL
      form.style = 'visibility: hidden'
      form.id = 'form-pay-online'
      form.name = 'formPayOnline'
      
      const payData = [
        {
          name: 'Amount',
          value: Math.abs(+this.currentContractDebt)*100
        },
        {
          name: 'TranId',
          value: Date.now()
        },
        {
          name: 'OrderId',
          value: this.currentContractNumber
        },
        {
          name: 'Service',
          value: process.env.VUE_APP_KSPI_SERVICE
        },
        {
          name: 'returnUrl',
          value: process.env.VUE_APP_PAY_SUCCESS
        },
        {
          name: 'Signature',
          value: ''
        },
        {
          name: 'user-agreement',
          value: 'согласие с договором публичной оферты'
        },
      ]
      
      payData.forEach(item => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = item.name
        input.value = item.value
        form.appendChild(input)
      })
      document.body.appendChild(form)
      setTimeout(() => {
        document.getElementById('form-pay-online').submit();
      }, 0)
      
    },

    async woopayAuth() {
      let authData = {
        login: process.env.VUE_APP_WOOPPAY_AUTH_LOGIN,
        password: process.env.VUE_APP_WOOPPAY_AUTH_PASSWORD
      }

      try {
        const resp = await this.authWooppay(authData);
        const oneDay = 86400000
        this.saveTokenWithExpiry("wtkn", resp.data.token, oneDay)
        return resp.data.token; 
      } catch (error) {
        toastr.error("Ошибка при авторизаций в системе оплаты");
        throw error; 
      }
    },

    async woopayBalanceAuth() {
      let authData = {
        login: process.env.VUE_APP_WOOPPAY_AUTH_LOGIN,
        password: process.env.VUE_APP_WOOPPAY_AUTH_PASSWORD
      }

      try {
        const resp = await this.authWooppayB(authData);
        const oneDay = 86400000
        this.saveTokenWithExpiry("wtknb", resp.token, oneDay)
        return resp.token; 
      } catch (error) {
        toastr.error("Ошибка при авторизаций в системе оплаты");
        throw error; 
      }
    },

    saveTokenWithExpiry(key, val, ttl) {
      const now = new Date()
      const item = {
        value: val,
        expiry: now.getTime()+ttl
      }
      localStorage.setItem(key, JSON.stringify(item));
    },  
    getTokenWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    },
    async wooppayPay(tkn, payMethods){
      this.ext_id = `${this.currentContractNumber}_${crypto.randomUUID()}`;
      const service = payMethods.includes('card') ? process.env.VUE_APP_WOOPPAY_SERVICE_SSL : process.env.VUE_APP_WOOPPAY_SERVICE_AP
      let payData = {
        "token": tkn,
        "data": {
          "amount": this.amountForWooppay,
          "external_id": this.ext_id,
          "service": service,
          "merchant": process.env.VUE_APP_WOOPPAY_MERCHANT,
          "regulations": {
            "language": this.lang,
            "user_phone_required": payMethods.includes('card') ? false : true,
            "payment_methods": payMethods,
            "client_identification": {
              "phone": `7${this.profile.phone}`,
              "email": this.profile.email,
            },
            "behavior": {
              "result_url": {
                "url": "https://wpay.ttc.kz/paysystems/WooppayExchange",
                "type": "post"
              },
              "auto_redirect": false,
              "success_url": `${process.env.VUE_APP_PAY_SUCCESS}/${this.ext_id}`,
              "failure_url": process.env.VUE_APP_PAY_ERROR
            },
            "description": {
              "main": "Оплата услуг",
              "internal_comment": "Оплата услуг"
            }
          }
        }
      }

      try {
        const resp = await this.paymentWooppay(payData);
        return resp.data;
      } catch (error) {
        toastr.error("Ошибка при получений счета на оплату");
        throw error;
      }
    },
    async wooppayCard_AGP(payMethod) {
      if(this.amountForWooppay<10){
        toastr.error('Сумма должна быть больше 10 тг');
        return
      }
      this.showPreloader()
      try {
        let token = this.getTokenWithExpiry("wtkn")
        if (!token) {
          token = await this.woopayAuth();
        }
        const payMethods = payMethod === 'card' ? ['card', 'linked_card'] : [payMethod]
        const paymentResp = await this.wooppayPay(token, payMethods);
        if(payMethod.includes('apple_pay') || payMethod.includes('google_pay')){
          window.open(paymentResp.url, "_blank");
        }else{
          this.invoiceID = paymentResp.id
          this.getWooppayCard(token);
        }
      } catch (err) {
        toastr.error('Ошибка в процессе оплаты, попробуйте написать менеджеру');
      } finally {
        this.hidePreloader();
      }
    },

    async wooppayBalance() {
      if(this.amountForWooppay<10){
        toastr.error('Сумма должна быть больше 10 тг');
        return
      }
      this.showPreloader()
      try {
        let token = this.getTokenWithExpiry("wtknb")
        if (!token) {
          token = await this.woopayBalanceAuth();
        }
        await this.wooppayPayBalance(token);
        this.isVisible = 'wooppay-balance'
        // window.open(paymentResp.operation_url, "_blank");

      } catch (err) {
        toastr.error('Ошибка в процессе оплаты, попробуйте написать менеджеру');
      } finally {
        this.hidePreloader();
      }
    },
    async payBalance() {
      console.log(this.smsCode)
      this.showPreloader()
      try {
        let token = this.getTokenWithExpiry("wtknb")
        if (!token) {
          token = await this.woopayBalanceAuth();
        }
        const balanceData = {
          "sms_code": this.smsCode
        }
        const paymentResp = await this.payWoopBalance({token, balanceData});
        if(paymentResp === true){
          this.$refs.closeBtn.click()
          this.$router.push({name: 'pay-status', params: {id: this.ext_id}})
        }else{
          toastr.error(paymentResp.response.data[0].message, 'Ошибка в процессе оплаты:' );
        }
      } catch (err) {
        toastr.error('Ошибка в процессе оплаты, попробуйте написать менеджеру');
      } finally {
        this.hidePreloader();
      }
    },
    getCurrentDatePlus30Minutes() {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 30);

      const pad = n => String(n).padStart(2, '0');

      const formattedDate = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
      const formattedTime = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

      return `${formattedDate} ${formattedTime}`;
    },
    async wooppayPayBalance(tkn){
      this.ext_id = `${this.currentContractNumber}_${crypto.randomUUID()}`;
      let payData = {
        "reference_id": this.ext_id,
        "amount": this.amountForWooppay,
        "death_date": this.getCurrentDatePlus30Minutes(),
        "merchant_name": process.env.VUE_APP_WOOPPAY_MERCHANT,
        "request_url": {
          "url": "https://wpay.ttc.kz/paysystems/WooppayExchange",
          "type": "POST"
        },
        "back_url": `${process.env.VUE_APP_PAY_SUCCESS}/${this.ext_id}`,
        "option": 2,
        "description":"Ваш текст комментария",
        "user_phone": this.normalizePhoneNumber(this.phoneNumberForWooppay),
        "add_info": {
          "about": "Оплата задолжности",
          "offer":"https://cabinet.ttc.kz/finances",
          "invoice_lang": this.lang,
        },
        "service_name": process.env.VUE_APP_WOOPPAY_SERVICE,
        "card_forbidden": "1"
      }


      try {
        const resp = await this.paymentWooppayBalance({tkn, payData});
        return resp;
      } catch (error) {
        toastr.error("Ошибка при получений счета на оплату");
        throw error;
      }
    },

    normalizePhoneNumber(phone) {
      let digits = phone.replace(/\D/g, '');

      if (digits.startsWith('8')) {
        digits = '7' + digits.slice(1);
      } else if (digits.length === 10) {
        digits = '7' + digits;
      } else if (digits.startsWith('7') && digits.length > 11) {
        digits = digits.slice(-10);
        digits = '7' + digits;
      }

      return digits;
    },

    async getWooppayCard() {
      const token = this.getTokenWithExpiry("wtkn")
      try {
        const resp = await this.getCards({
                      "token": token,
                      "id": {
                        "invoice_key": this.invoiceID
                      }
                    });
        this.isVisible = 'wooppay'
        this.wooppayCardList = resp.data;
      } catch (error) {
        toastr.error('Ошибка при получении списка карт');
        throw error;
      }
    },

    async payNewCard() {
      this.showPreloader()
      try {
        const token = this.getTokenWithExpiry("wtkn")
        let data = {
          "type": "card",
          "parameters": {
            "invoice_key": this.invoiceID,
            "phone": `7${this.profile.phone}`
          }
        };
        const resp = await this.payWithCard({token, data});
        window.open(resp.data.frame, "_blank");
      } catch (error) {
        toastr.error('Ошибка в процессе оплаты, попробуйте написать менеджеру');
        throw error;
      } finally {
        this.hidePreloader();
      }
    },
    async payExistCard(cardId) {
      this.showPreloader()
      try {
        const token = this.getTokenWithExpiry("wtkn")
        let data = {
          "type": "linked_card",
          "parameters": {
            "invoice_key": this.invoiceID,
            "card_id": cardId
          }
        };
        const resp = await this.payWithCard({token, data});
        if(!resp.data.frame && resp.data.paid){
          this.showModal = false
          this.$refs.closeBtn.click()
          this.$router.push({name: 'pay-status', params: {id: this.ext_id}})
          this.isVisible = 'methods'
        }else{
          window.open(resp.data.frame, "_blank");
        }
      } catch (error) {
        toastr.error('Ошибка в процессе оплаты, попробуйте написать менеджеру');
        throw error;
      } finally {
        this.hidePreloader();
      }
    },
    async deleteCard(id, token) {
      this.showPreloader()
      try {
        const resp = await this.deleteExistCard({
                      "token": token,
                      "invoiceID": this.invoiceID,
                      "id": {
                        "card_id": id
                      }
                    });
        if(resp === 204){
          this.getWooppayCard()
        }
      } catch (error) {
        toastr.error('Не получилось отвязать карту');
        throw error;
      } finally {
        this.hidePreloader();
      }
    },

    setContractData(cNumber, cDebt) {
      this.currentContractNumber = cNumber
      this.currentContractDebt = cDebt
      this.phoneNumberForWooppay = this.profile.phone
      this.amountForWooppay = Math.abs(this.currentContractDebt)
    },
    closeModal() {
      this.showModal = false;
      this.isVisible = 'methods';
    },
    showPreloader() {
      this.preloader.classList.remove('d-none')
    },
    hidePreloader() {
      this.preloader.classList.add('d-none');
    },
    // halykPay
    payEpay(){
      this.showPreloader()
      this.invoiceID = new Date().valueOf();
      let payData = {
        sum: this.paySumEpay,
        invoiceID: this.invoiceID
      }
      this.payment(payData).then((resp) => {
        this.pay(resp)
        // toastr.success("Успешно")
      }).catch((error) => {
        toastr.error("Ошибка")
      }).finally(() => {
        this.hidePreloader()
      });
    },
    pay(auth) {
      const { first_name, last_name, patronymic, email, phone } = this.profile
      // console.log("1", this.invoiceID)
      const paymentObject = {
          invoiceId: this.invoiceID,
          invoiceIdAlt: this.invoiceID,
          backLink: "https://cabinet.ttc.kz/finances",
          failureBackLink: "https://cabinet.ttc.kz/finances",
          postLink: "https://cabinet.ttc.kz/finances",
          failurePostLink: "https://cabinet.ttc.kz/finances",
          language: this.getLang(this.lang),
          description: "Пополнение баланса",
          accountId: "",
          terminal: "67e34d63-102f-4bd1-898e-370781d0074d",
          amount: this.paySumEpay,
          currency: "KZT",
          phone: phone,
          name: this.transliterate(first_name + " " + last_name),
          email: email,
          cardSave: false,
          auth: auth
      };
      halyk.pay(paymentObject)
    },
    transliterate(text) {
      const cyrillicToLatinMap = {
          'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
          'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
          'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
          'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch', 'ъ': '',
          'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya', 'ә': 'a', 'і': 'i', 
          'ң': 'n', 'ғ': 'g', 'ү': 'u', 'ұ': 'u', 'қ': 'k', 'ө': 'o', 'һ': 'h'
      };
      return text.toLowerCase().split('').map(char => cyrillicToLatinMap[char] || char).join('').toUpperCase();
    },
    getLang(text){
      let lang;
      switch (text) {
        case 'kz': lang = 'kaz'; break;
        case 'ru': lang = 'rus'; break;
        case 'en': lang = 'eng'; break;
      }
      return lang;
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapGetters({
      finance: 'finance/finance',
      userId: 'authorization/getUserId',
      profile: 'profile/profileData',
      lang: 'assistant/lang'
    })
  },
  created() {
    document.querySelector('.preloader').classList.remove('d-none')
    this.getFinance().then(res => {
      if (res === 200) {
        document.querySelector('.preloader').classList.add('d-none');
        this.loaded = true
      }
    });
  }
}
</script>
<style scoped>
.show{
  opacity: 1;
  display: block;
  background: rgba(255,255,255,.5);
}
.is_disabled{
  background-color: #ddd !important;
  color: #a7a7a7;
  border-color: #ddd;
}
.modal-body{
  overflow: inherit;
}
.payment-methods{
  display: flex;
  flex-direction: column;
}
.payment-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #E4E7EC;
  padding-top: 12px;
  padding-bottom: 10px;
  width: 100%;
  cursor: pointer;
  transition: all .2s ease-in;
}
.payment-item:last-child{
  border-bottom: 1px solid #E4E7EC;
}
.payment-item:hover{
  background-color: #f5f2f2;
}
.payment-title{
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
}
.epay{
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.card-list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.card-pay{
  display: flex;
  flex-direction: column;
}
.card{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #E4E7EC;
  border-bottom: 1px solid #E4E7EC;
  width: 100%;
}
.card-data{
  padding: 2px;
  padding-top: 12px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  flex-grow: 1;
}
.card-data:hover{
  background-color: #f5f2f2;
  cursor: pointer;
}
.card-delete{
  transition: all .2s ease-in;
  cursor: pointer;
}
.card-delete:hover>svg{
  fill: rgb(146, 8, 8);
}
.payment-btn{
  border-top: 1px solid #E4E7EC;
  padding-top: 15px;
}
.pay-btns{
  display: flex; 
  align-items: center; 
  justify-content: center; 
  width: 100%; 
  gap: 20px;
}
.pay-btn{
  padding: 10px 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-btn:hover{
  cursor: pointer;
  transition: all .2s ease-in;
  background-color: #f5f2f2;
}
.pay-balance-form{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.form-alt{
  font-size: 0.7em;
  color: #979797;
  padding-top: 3px;
}
</style>